import { Injectable } from '@angular/core';
import { UserModel } from '../models/user.model';
import { Subject, Observable } from "rxjs";

@Injectable()
export class GlobalService {

    public appVersion: string = "2.02"
    // User
    public user: UserModel = new UserModel();
    private User = new Subject<UserModel>();
    public $userViewer = this.User.asObservable();
    public hasLoaded: boolean = false;
    public lastTimeAskedToInstall: string = null;

    public overrideInstallRequirement: boolean = false;
    // public overrideLoginInstructions : boolean = false;

    public isInstalled: boolean = false;
    public isiOS: boolean = false;
    public device: string = '';
    public isConnected: boolean = true;

    public hseUser: boolean = false;
    public opsUser: boolean = false;
    public finUser: boolean = false;
    public currentPage: number = 0;

    SetUser(user: UserModel) {
        this.user = user;
        this.User.next(user);
    }

    GetUser(): Observable<UserModel> {
        return this.User.asObservable();
    }

    ClearUser() {
        var user: UserModel = new UserModel();
        this.userLoggedIn = false;
        this.User.next(user);
    }

    //User logged in
    public userLoggedIn: boolean;
    SetUserLoggedIn(loggedIn: boolean) {
        this.userLoggedIn = loggedIn;
    }

    NotNullString(value: any) {
        if (value == undefined)
            return '';
        return value;
    }

    NewLine() {
        return String.fromCharCode(13, 10); //'&#13;&#10;';
    }
}
